<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.inventory.rawMaterial')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="#">
              <span>{{$t('tlt.inventory.rawMaterial')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.basic.matCode')}}</label>
                  <dimsearch
                    v-model="matCodeFilter"
                    :entity="materials"
                    bindId="rawMaterialFilter"
                    bindProp="matCode"
                    submitProp="matCode"
                  ></dimsearch>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.basic.matName')}}</label>
                  <dimsearch :entity="materials" bindId="rawMaterialFilter" bindProp="matName"></dimsearch>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.inventory.invCode')}}</label>
                  <dimsearch
                    v-model="invCodeFilter"
                    :entity="locations"
                    bindId="rawLocationFilter"
                    bindProp="invCode"
                    submitProp="invCode"
                  ></dimsearch>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.inventory.invName')}}</label>
                  <dimsearch :entity="locations" bindId="rawLocationFilter" bindProp="invName"></dimsearch>
                </div>
                <div class="col-lg-4 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="clearFilter()"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('rawMaterial')">
                      <!--button class="btn btn-primary" type="button" v-on:click="saveNew()"-->
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{$t('btn.basic.search')}}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="rawMaterialResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <div class="bs-component"></div>
              <mmf-table entity="rawMaterial" inline-actions-disabled disableDelete disableEdit singleChoice>
                <div slot="btnList" class="btn-group" slot-scope="slotProps">
                  <b-button
                    v-b-modal.modal-1
                    variant="outline-primary"
                    :disabled="slotProps.checkedLength !=1"
                  >
                    <i class="fa fa-pencil-alt" aria-hidden="true"></i>
                    <span class="text">{{$t('btn.inventory.adjustInventory')}}</span>
                  </b-button>
                </div>
              </mmf-table>
            </div>
          </div>
        </div>admina
      </div>
    </section>
    <b-modal id="modal-1" title="库存调差" @ok="receive('rawMaterial')">
      <b-container fluid>
        <b-row class="mb-1 text-center">
          <b-col>{{$t('lbl.rawMaterial.curInventory')}}</b-col>
          <b-col>{{$t('lbl.rawMaterial.adjustTime')}}</b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col>
            <input class="form-control" type="text" v-model="curInventory" />
          </b-col>
          <b-col>
            <mmf-datetimepicker v-model="adjustTime"></mmf-datetimepicker>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions, Store } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { gridFields, filterFields } from "@/model/prd/inventoryMgt/RawMaterial";
import MmfTable from "@/components/MmfTable";
import MmfButton from "@/components/MmfButton";
import dimsearch from "@/components/MMFDimSearch";
import MmfDatetimepicker from "@/components/MmfDatetimepicker";

const { mapFields } = createHelpers({
  getterType: "rawMaterial/getField",
  mutationType: "rawMaterial/updateField"
});

export default {
  name: "rawMaterial",
  data() {
    return {
      materials: [],
      locations: [],
      curInventory: "",
      adjustTime: ""
    };
  },
  components: {
    MmfTable,
    MmfButton,
    dimsearch,
    MmfDatetimepicker
  },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.rawMaterial.rows,
      tableColumns: gridFields,
      entity: state => state.rawMaterial.entity,
      checkedItems: state => state.rawMaterial.checkedItems,
      selectedItem: state => state.rawMaterial.entity
    })
  },
  methods: {
    ...mapActions("rawMaterial", ["Receive"]),
    ...mapActions("base", [
      "MMFselectRow",
      "MMFselectAllRows",
      "MMFNew",
      "MMFEdit",
      "MMFLoadRows",
      "MMFDelete",
      "MMFClearFilter"
    ]),
    receive(moudle) {
      this.entity.curInventory = this.curInventory;
      this.entity.adjustTime = this.adjustTime;
      this.Receive(moudle);
    },
    actionDisabled() {
      return this.checkedItems.length != 1;
    },
    // loadDistributions(matCode) {
    //   this.$store.dispatch("materialPile/changeMatCode", matCode);
    //   this.MMFLoadRows("materialPile");
    // },
    clearFilter() {
      this.$store.dispatch("dimSearch/initBind", {
        rawMaterialFilter: {}
      }),
        this.$Store.dispatch("dimsearch/ininBind", {
          rawLocationFilter: {}
        }),
        this.MMFClearFilter("rawMaterial");
    }
  },
  mounted() {
    //自动加载页面 this.MMFLoadRows("rawMaterial");
    this.$store
      .dispatch(
        "api/get",
        {
          url: this.$store.state.location.baseModuleUrl + "/material/findAll"
        },
        {
          root: true
        }
      )
      .then(data => {
        data.push({});
        this.materials = data;
      }),
      this.$store
        .dispatch(
          "api/get",
          {
            url:
              this.$store.state.location.baseModuleUrl + "/location/findByPerId"
          },
          {
            root: true
          }
        )
        .then(data => {
          data.push({});
          this.locations = data;
        });
  }
};
</script>
